import { RelayType } from '@diritto/common/content/constants';
import { ContentsRelayResponseDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { RelayApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';

const getData = (contentId: number, data: ContentsRelayResponseDto) => {
  const content = data.contents[contentId];
  const contentPublic = content.relayType === RelayType.Public ? content : undefined;
  const authorProfile =
    contentPublic && contentPublic.profileId ? data?.profileLites[contentPublic.profileId] : undefined;
  const authorProfilePublic = !authorProfile?.isDeleted ? authorProfile : undefined;

  return {
    content,
    contentPublic,
    authorProfile,
    authorProfilePublic,
  };
};

export const usePostRelayContentQuery = (contentId: number) =>
  useQuery({
    queryKey: relayQueryKey.content(contentId),
    queryFn: async () => getData(contentId, await RelayApi.contents({ contentIds: [contentId], includeAdult: true })),
    staleTime: 1000 * 60 * 60 * 24,
  });

export const prefetchRelayContent = async (queryClient: QueryClient, contentId: number) =>
  queryClient.prefetchQuery({
    queryKey: relayQueryKey.content(contentId),
    queryFn: async () => getData(contentId, await RelayApi.contents({ contentIds: [contentId], includeAdult: true })),
    staleTime: 1000 * 60 * 60 * 24,
  });
